import { Stack } from "@mui/material";

import { ExportModality } from "../../constants";
import { ExportFormModality2dOptions } from "./components/ExportFormModality2dOptions";
import { ExportFormVideoOptions } from "./components/ExportFormVideoOptions";

interface ExportFormModalityOptionsProps {
  exportModality: ExportModality;
}

export const ExportFormModalityOptions = (
  props: ExportFormModalityOptionsProps,
) => {
  const { exportModality } = props;

  return (
    <Stack spacing={3} sx={{ flex: "1 1 0", minWidth: 0 }}>
      {exportModality === "image" && <ExportFormModality2dOptions />}
      {exportModality === "video" && <ExportFormVideoOptions />}
    </Stack>
  );
};
